import { FileText, Clock } from 'lucide-react';

export const AuditAdminTab = ({ loading, auditLogs, formatDate }) => (
    <div className="card-dark p-6">
        <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
            <FileText className="w-5 h-5 text-[#FFD700]" />
            Audit Logs
        </h3>
        {loading ? (
            <div className="flex justify-center py-12"><div className="spinner" /></div>
        ) : auditLogs.length === 0 ? (
            <p className="text-center text-[#A0AAB2] py-12">No audit logs yet</p>
        ) : (
            <div className="space-y-3">
                {auditLogs.map((log, i) => (
                    <div key={i} className="p-4 rounded-lg bg-white/5 border border-white/10">
                        <div className="flex items-center justify-between mb-2">
                            <span className="px-2 py-1 rounded text-xs font-medium bg-[#FFD700]/20 text-[#FFD700]">{log.action}</span>
                            <span className="text-[#A0AAB2] text-sm flex items-center gap-1">
                                <Clock className="w-4 h-4" />
                                {formatDate(log.created_at)}
                            </span>
                        </div>
                        <p className="text-white text-sm">Admin: {log.admin_email}</p>
                        {log.target_user_id && <p className="text-[#A0AAB2] text-sm">Target User: {log.target_user_id}</p>}
                        {log.details && (
                            <pre className="text-xs text-[#A0AAB2] mt-2 p-2 rounded bg-black/30 overflow-x-auto">
                                {JSON.stringify(log.details, null, 2)}
                            </pre>
                        )}
                    </div>
                ))}
            </div>
        )}
    </div>
);
